import type { ButtonHTMLAttributes } from "react";
import { deleteIcon } from "../../../../icons/deleteIcon";

interface DeleteButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "title"
> {
  onClick: () => void;
  title?: string;
}

export const DeleteButton = ({
  onClick,
  title,
  className = "",
  ...buttonProps
}: DeleteButtonProps) => {
  const displayTitle = title ?? "";

  return (
    <button
      type="button"
      onClick={onClick}
      className={`p-1.5 text-global-error hover:text-global-error hover:bg-global-error rounded-md transition-all ${className}`.trim()}
      title={displayTitle}
      {...buttonProps}
    >
      {deleteIcon}
    </button>
  );
};
